import { Dispatch } from "@reduxjs/toolkit";
import { apiPost } from "./generic.api";

export interface AiReport {
  report: string;
  treatment: string;
  differentialDiagnosis: string;
}

export const generateReport = async (
  dispatch: Dispatch,
  reportText: string
): Promise<AiReport> => {
  return (
    (
      await apiPost<{ aiReport: AiReport }, { reportText: string }>(
        dispatch,
        `api/report/generate`,
        { reportText }
      )
    )?.aiReport || {}
  );
};
